// extracted by mini-css-extract-plugin
export var cookieBanner = "CookieBanner-module--cookieBanner--7b1dc";